import AntIcon, { LoadingOutlined } from "@ant-design/icons"
import cx from "clsx"
import PropTypes from "prop-types"
import chroma from "chroma-js"
import { Tooltip } from ".."
import * as ReactIcons from "../../icons"
import * as LocalIcons from "../../svg"
import styles from "./index.module.less"

const getDynamicStyle = color => {
  if (!color) return {}
  return {
    "--icon-bg-color": chroma(color).alpha(0.1).css(),
    "--icon-color": color,
  }
}

function Icon(props) {
  const {
    icon,
    size,
    className,
    hasBackground,
    tooltipText,
    iconContainerStyle,
    flip,
    placement = "top",
    isLoading,
    overlayInnerStyle,
    color,
    square,
    ...rest
  } = props

  const Component = ReactIcons[icon] || LocalIcons[icon]

  const dynamicBgStyle = hasBackground ? getDynamicStyle(color) : {}

  const componentProps = {
    size,
    ...rest,
    style: !hasBackground && color ? { color, ...rest.style } : rest.style,
  }

  const getIcon = () =>
    !!tooltipText ? (
      <Tooltip placement={placement} title={tooltipText} overlayInnerStyle={overlayInnerStyle}>
        <AntIcon
          className={cx(styles.icon, className)}
          component={() => (Component ? <Component {...componentProps} /> : null)}
        />
      </Tooltip>
    ) : (
      <AntIcon
        className={cx(styles.icon, className)}
        component={() => (Component ? <Component {...componentProps} /> : null)}
      />
    )

  const iconContent = () =>
    isLoading ? <LoadingOutlined style={{ fontSize: size }} size={size} {...rest} spin /> : getIcon()

  return hasBackground ? (
    <div
      className={cx(styles.iconStyled, { [styles.square]: square })}
      style={{ ...dynamicBgStyle, ...iconContainerStyle }}
    >
      {iconContent()}
    </div>
  ) : (
    iconContent()
  )
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  square: PropTypes.bool,
}

Icon.defaultProps = {
  size: "1.2em",
  square: false,
}

export default Icon
